module.exports = __webpack_public_path__ + "img/dark_brand_allsan.1c699147.gif";